import React from "react";

export default function GTMScoreCard({score}){

const safeScore =
Number.isFinite(score)
? score
: 0;

/* INTERPRET SCORE */

function scoreMeaning(value){

if(value <= 2)
return "Idea stage. Validate ICP and problem.";

if(value <= 4)
return "Early GTM forming. Improve positioning.";

if(value <= 6)
return "Foundation ready. Focus acquisition testing.";

if(value <= 8)
return "Launch ready. Execute channels aggressively.";

return "Strong GTM readiness. Focus scaling.";

}

function scoreColor(value){

if(value <= 3)
return "text-red-600";

if(value <= 6)
return "text-amber-600";

return "text-green-600";

}

return(

<div className="bg-white border rounded-xl p-6 shadow-sm">

<h3 className="text-lg font-semibold text-blue-900">

GTM Readiness Score

</h3>

<div className={`text-5xl font-bold mt-4 ${scoreColor(safeScore)}`}>

{safeScore}/10

</div>

<p className="text-sm text-slate-600 mt-3">

{scoreMeaning(safeScore)}

</p>

<div className="mt-4 text-xs text-slate-500 border-t pt-3">

Score based on:
Strategy • ICP • Positioning • Channels • Experiments • Roadmap • Metrics • Risks • Execution actions

</div>

</div>

);

}